<template>
  <div class="wrapper">
    <el-tabs
      type="border-card"
      :before-leave="tabsChange"
      class="content"
      v-model="tabShowing"
    >
      <el-tab-pane label="从题库随机选择试题" name="0" v-if="!ifQuestion">
        <div class="tips">
          点击"选择分类"按钮打开分类窗口选择分类，然后输入选择试题数目
        </div>
        <p><strong>已选择的分类</strong></p>
        <p>
          将从&nbsp;{{ groupCountList.length }}&nbsp;个分类随机抽取&nbsp;{{
            staticCount
          }}&nbsp;个试题<span class="greyFont"
            >&nbsp;(已在试卷的题不会在显示在分类列表中)</span
          >&nbsp;&nbsp;总分{{ staticScore }}分
        </p>
        <div
          class="questionGroupBar"
          v-for="(item, index) in groupCountList"
          :key="'groupCount' + index"
        >
          <div class="questionGroupTitle">
            <i class="el-icon-s-unfold"></i>
            <i
              class="el-icon-delete-solid"
              @click="groupCountList.splice(index, 1)"
            ></i>
            <div class="groupName" @click="item.ifMore = !item.ifMore">
              {{ item.groupName }}({{ item.groupNum }}道试题)<i
                class="el-icon-arrow-down"
              ></i>
            </div>
            <div class="selectDetail">
              {{ item | questionCountCalculate }}
            </div>
          </div>
          <div
            class="questionTypeList"
            :style="{
              height: item.ifMore
                ? 40 * item.examRandomDTOList.length + 'px'
                : '0px',
            }"
          >
            <div
              class="typeCell"
              v-for="(type, typeIdx) in item.examRandomDTOList"
              :key="'typeCount' + typeIdx"
            >
              <div class="typeName">
                {{ type.typeName }}({{ type.totalNum }}道试题)
              </div>
              <div class="typeNum">
                抽选<el-input
                  size="small"
                  type="number"
                  min="0"
                  :max="type.totalNum"
                  @change="
                    (val) => {
                      groupDataCalculate(val, item, type);
                    }
                  "
                  v-model="type.randomNum"
                  style="width: 80px"
                ></el-input
                >道试题
              </div>
              <div class="typeScore">
                每题<el-input
                  size="small"
                  type="number"
                  @change="groupDataCalculate(null, item)"
                  min="0"
                  v-model="type.score"
                  style="width: 60px"
                ></el-input
                >分
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="手动从题库中选择试题" name="1">
        <div class="twoSideBox">
          <div
            class="leftBox"
            ref="treeBox"
            style="width: 200px; overflow-y: scroll"
          >
            <el-tree
              :data="questionTypeTree"
              @current-change="questionTypeChange"
              default-expand-all
              node-key="id"
              ref="questionChooseTree"
              highlight-current
              :props="{ label: 'title' }"
            >
            </el-tree>
          </div>
          <div class="slider" @mousedown="sliderClick"></div>
          <div class="rightBox">
            <div class="searchBar">
              <el-checkbox
                :value="manualAppendIfSelectAll"
                @change="selectAllQuestion"
                style="margin-right: 15px"
              ></el-checkbox>
              <span class="smallFont">请选择难易程度：</span>
              <el-select
                v-model="questionSearchCondition.levelId"
                placeholder="请选择"
                style="width: 120px"
                @change="searchQuestion({ ifInit: true })"
                size="small"
              >
                <el-option
                  v-for="item in levelList"
                  :key="item.name + item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              &ensp;
              <span class="smallFont">请选择题型：</span>
              <el-select
                v-model="questionSearchCondition.typeId"
                placeholder="请选择"
                style="width: 120px"
                @change="searchQuestion({ ifInit: true })"
                size="small"
              >
                <el-option
                  v-for="item in questionTypeList"
                  :key="item.typeName"
                  :label="item.typeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="questionContainer">
              <div
                class="questionBar"
                v-for="(item, index) in searchQuestionList"
                :key="'searchQuestionList' + item.id"
                @click.prevent="appendQuestion(item)"
              >
                <el-checkbox
                  :value="questionIds.includes(item.id)"
                  @change="appendQuestion(item)"
                  style="margin-right: 15px"
                ></el-checkbox>
                <div class="questionBox">
                  <div class="titleBar">
                    <div class="left">
                      <span class="blueFont blueBorder"
                        >{{
                          questionSearchCondition.pageSize *
                            (questionSearchCondition.jumpPage - 1) +
                          index +
                          1
                        }}/{{ questionSearchCondition.total }}</span
                      ><span class="blueFont blueBorder">{{
                        item.questionType
                      }}</span
                      ><span>{{ item.content | removeLabel }}</span>
                    </div>
                    <div class="right">
                      <span>{{ item.score }}分</span>&emsp;
                      <!-- <span>展开</span> -->
                    </div>
                  </div>
                  <div class="labelBar greyFont">
                    标签：
                    <div class="circlelabel">{{ item.labelName }}</div>
                  </div>
                  <div class="detailBar greyFont">
                    分类：{{ item.groupName }} | 作者：{{ item.accountName }} |
                    更新于：{{ item.createDate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          :current-page.sync="questionSearchCondition.jumpPage"
          @current-change="searchQuestion"
          :total="questionSearchCondition.total"
          layout="prev, pager, next"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <div class="buttonBar" v-show="tabShowing == 0">
      <el-button type="primary" plain @click="chooseType">选择分类</el-button>
      <el-button
        type="primary"
        @click="questionConfirm"
        v-show="groupCountList.length && staticCount"
        >确定</el-button
      >
    </div>

    <el-dialog
      :visible.sync="ifTypeChoose"
      width="40%"
      title="请选择试题分类"
      :modal="false"
    >
      <!-- @node-click="nodeClick" -->
      <el-tree
        :data="questionTypeTree"
        :check-on-click-node="true"
        show-checkbox
        default-expand-all
        node-key="id"
        ref="questionTypeTree"
        fullscreen
        highlight-current
        :props="{ label: 'title' }"
      >
      </el-tree>
      <template slot="footer"
        ><el-button @click="ifTypeChoose = false">取消</el-button>
        <el-button type="primary" @click="questionTypeConfirm"
          >选择</el-button
        ></template
      >
    </el-dialog>
  </div>
</template>

<script>
import {
  getQuestionType,
  createQuestion,
  getQuestionDetail,
  updateQuestion,
  uploadSign,
  getQuestionCount,
  questionSearch,
  getRandomQuestion,
  getLevelList,
  getQuestionTypeList,
} from "@/api/question.js";
export default {
  props: {
    questionIds: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ifQuestion: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      ifShow: false,
      ifMore: false,
      ifTypeChoose: false,
      tabShowing: "1",
      questionTypeTree: [],
      searchQuestionList: [],
      groupCountList: [],
      levelList: [],
      questionSearchCondition: {
        groupId: 0,
        pageSize: 10,
        jumpPage: 1,
        levelId: "",
        total: 0,
        questionLevelId: 0,
        typeId: "",
      },
      questionTypeList: [],
    };
  },
  created() {},
  computed: {
    staticCount() {
      let back = this.groupCountList.reduce((total, group) => {
        return total + group.totalCount;
      }, 0);
      return back;
    },
    staticScore() {
      let back = this.groupCountList.reduce((total, group) => {
        return total + group.totalScore;
      }, 0);
      return back;
    },
    manualAppendIfSelectAll() {
      return (
        this.searchQuestionList.every((item) =>
          this.questionIds.includes(item.id)
        ) && this.searchQuestionList.length > 0
      );
    },
  },
  mounted() {
    console.log(this.$refs.treeBox.style.width);
    this.$refs.treeBox.style.width = "300px";
    getQuestionType().then((data) => {
      data.groupNodeList.unshift({
        description: null,
        id: 0,
        parentId: 0,
        title: "所有分类",
      });
      this.questionTypeTree = data.groupNodeList;
      console.log(data.groupNodeList);
    });
    getQuestionTypeList().then((data) => {
      data.unshift({ id: "", typeName: "所有题型" });
      this.questionTypeList = data;
    });
    getLevelList().then((data) => {
      data.unshift({ name: "所有难度", id: "" });
      this.levelList = data;
      console.log(data);
    });
    this.$refs.questionChooseTree.setCurrentKey(0);
    this.searchQuestion({ id: 0 });
  },
  filters: {
    questionCountCalculate(item) {
      let [num, score] = item.examRandomDTOList.reduce(
        (total, item) => {
          total[0] -= -item.randomNum;
          total[1] -= -(item.score * item.randomNum);
          return total;
        },
        [0, 0]
      );
      return `抽取 ${num} 道题 总共 ${score} 分`;
    },
    removeLabel(str) {
      return str.replace(/<.*?>/gi, "");
    },
  },
  methods: {
    questionConfirm() {
      let theBack = this.groupCountList.reduce((total, group) => {
        return group.examRandomDTOList.reduce((typeTotal, type) => {
          if (type.randomNum) {
            typeTotal.push({
              groupId: group.groupId,
              typeId: type.typeId,
              randomNum: type.randomNum,
              score: type.score,
            });
          }
          return typeTotal;
        }, total);
      }, []);
      getRandomQuestion({ dtoList: theBack }).then((data) => {
        this.$emit("appendQuestion", data);
      });
    },
    appendQuestion(item) {
      item.questionId = item.id;
      this.$emit("appendQuestion", [item], { ifHandAppend: true });
    },
    selectAllQuestion(value) {
      if (this.manualAppendIfSelectAll) {
        console.log(
          this.searchQuestionList.filter((item) =>
            this.questionIds.includes(item.id)
          )
        );
        this.$emit(
          "appendQuestion",
          this.searchQuestionList.filter((item) =>
            this.questionIds.includes(item.id)
          ),
          { ifHandAppend: true }
        );
      } else {
        this.$emit(
          "appendQuestion",
          this.searchQuestionList.filter(
            (item) => !this.questionIds.includes(item.id)
          ),
          { ifHandAppend: true }
        );
      }
      this.$forceUpdate();
    },
    questionTypeChange(data) {
      this.questionSearchCondition.groupId = data.id;
      this.searchQuestion();
    },
    searchQuestion(options) {
      if (options && options.ifInit) {
        this.questionSearchCondition.jumpPage = 1;
      }
      questionSearch(this.questionSearchCondition).then((data) => {
        data.respList.forEach((item) => {
          item.questionId = item.id;
        });
        this.searchQuestionList = data.respList;
        this.questionSearchCondition.total = data.total;
        console.log(data);
      });
    },
    groupDataCalculate(val, item, type) {
      if (val && val > type.totalNum) {
        type.randomNum = type.totalNum;
      }
      [item.totalCount, item.totalScore] = item.examRandomDTOList.reduce(
        (total, item) => {
          total[0] -= -item.randomNum;
          total[1] -= -(item.score * item.randomNum);
          return total;
        },
        [0, 0]
      );
    },
    chooseType() {
      this.ifTypeChoose = true;
      this.$nextTick(() => {
        console.log(this.groupCountList);
        this.$refs.questionTypeTree.setCheckedKeys(
          this.groupCountList.map((item) => item.groupId)
        );
      });
    },
    questionTypeConfirm() {
      let nodes = this.$refs.questionTypeTree.getCheckedNodes();
      // console.log(this.$refs.questionTypeTree.getCheckedNodes(),this.$refs.questionTypeTree.getCheckedNodes(true));
      let groupIds = nodes.map((item) => item.id);
      if (groupIds.length > 0) {
        getQuestionCount({
          groupIds: "[" + groupIds.toString() + "]",
          levelName: "",
        }).then((data) => {
          let groupIds = this.groupCountList.map((item) => item.groupId);
          data.forEach((item) => {
            item.examRandomDTOList.forEach((type) => (type.randomNum = 0));
            if (!groupIds.includes(item.groupId)) {
              item.ifMore = false;
              item.totalCount = 0;
              item.totalScore = 0;
              this.groupCountList.push(item);
            }
          });
          this.ifTypeChoose = false;
        });
      } else {
        this.$message.warning("请选择至少一个分类");
        // this.ifTypeChoose = false;
      }
    },
    nodeClick(data, node) {
      let checkedKeys = this.$refs.questionTypeTree.getCheckedKeys(true);
      if (data.id && !checkedKeys.includes(0)) {
        // 点击的不是所有分类且没选择所有分类
        if (checkedKeys.includes(data.id)) {
          checkedKeys.splice(checkedKeys.indexOf(data.id), 1);
        } else {
          checkedKeys.push(data.id);
        }
      } else if (data.id && checkedKeys.includes(0)) {
        // 点击的不是所有分类且已选择所有分类
        checkedKeys = [data.id];
      } else {
        // 点击所有分类
        checkedKeys = [data.id];
      }
      this.$refs.questionTypeTree.setCheckedKeys(checkedKeys);
    },
    tabsChange(data) {
      console.log(data);
      if (data == 1) {
        this.$refs.questionChooseTree.setCurrentKey(0);
        this.searchQuestion({ id: 0 });
      }
    },
    sliderClick(event) {
      let widthReduce = document.body.scrollWidth * 0.1;
      let widthMin = widthReduce + 250;
      document.onmousemove = (event) => {
        if (event.screenX > widthMin) {
          this.$refs.treeBox.style.width = event.screenX - widthReduce + "px";
        }
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
  },
};
</script>

<style scoped lang="less">
.blueFont {
  color: #409eff;
}
.greyFont {
  color: #999;
}
.circlelabel {
  display: inline-block;
  border: 1px solid #ccc;
  padding: 6px;
  line-height: 16px;
  margin-right: 10px;
  border-radius: 15px;
}
.blueBorder {
  border: 1px solid #409eff;
  margin-right: 5px;
  border-radius: 2px;
  padding: 2px 4px;
}
.wrapper::-webkit-scrollbar {
  display: none;
}
.wrapper {
  // position: fixed;
  // z-index: 1;
  // top: 0;
  // left: 0;
  // width: 100%;
  // height: 100%;
  // background: rgba(0, 0, 0, 0.3);
  // font-size: 16px;
  max-height: 75vh;
  overflow: scroll;
  font-size: 16px;
  .content {
    // width: 60%;
    // margin: 15% calc(100px + 20%);
    // max-height: 60vh;
    // overflow: scroll;
  }
  .el-pagination {
    text-align: right;
    margin-top: 5px;
  }
  .tips {
    background-color: #eef7ea;
    color: #3c763d;
    margin: 0 0 20px 0;
    padding: 15px 30px 15px 15px;
    border-left: 5px solid #bbdba1;
  }
  .questionGroupTitle {
    display: flex;
    align-items: center;
    line-height: 24px;
    i {
      line-height: inherit;
      margin-right: 10px;
      font-size: 20px;
    }
    .groupName {
      min-width: 300px;
      margin-right: 15px;
      cursor: pointer;
    }
    .selectDetail {
      min-width: 150px;
    }
  }
  .questionTypeList {
    overflow: hidden;
    margin: 5px 0;
    transition: height 0.8s;
    .typeCell {
      height: 40px;
      display: flex;
      line-height: 40px;
      .typeName {
        margin-left: 60px;
        min-width: 305px;
      }
      .typeNum {
        margin: 0 10px;
      }
      .typeScore {
      }
    }
  }
  .twoSideBox {
    display: flex;
    position: relative;
    max-height: 60vh;
    .leftBox {
      // width: 200px;
    }
    .slider {
      width: 8px;
      background: rgba(0, 0, 0, 0.1);
      cursor: w-resize;
    }
    .rightBox::-webkit-scrollbar {
      display: none;
    }
    .rightBox {
      flex: 1;
      padding: 15px;
      min-height: 30vh;
      max-height: 70vh;
      overflow: scroll;
      .questionContainer {
        .questionBar {
          padding: 10px;
          background: #f6fbfc;
          display: flex;
          /deep/ .el-checkbox__inner {
            height: 20px;
            width: 20px;
          }
          /deep/ .el-checkbox__inner::after {
            width: 4px;
            height: 12px;
            left: 6px;
            top: 0;
            border-width: 2px;
          }
          .questionBox {
            border: 1px solid #ccc;
            background: #fff;
            padding: 20px;
            flex: 1;
            .titleBar {
              display: flex;
              justify-content: space-between;
              .left {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                padding: 2px 0;
                flex: 1;
              }
              .right {
                width: 100px;
                text-align: right;
              }
            }
            .labelBar {
              margin: 10px 0;
            }
          }
          .questionBox:hover {
            border-color: #409eff;
          }
        }
      }
    }
  }
  .buttonBar {
    margin-top: 10px;
  }
}

.el-input {
  margin: 0 5px;
}
</style>
